import { DialogWithForm } from '@strata/react-dialog';
import { TextInputFormik } from '@strata/react-inputs';
import { SuccessToast } from '@strata/react-toast-message';
import { validationStrings } from '@strata/strata-ui-strings';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { useRenameBatchMutation } from 'store/api/goLiveApi';

const Title = 'Rename batch';

export const RenameBatchDialog = ({ isOpen, onClose, batch = undefined }) => {
    const [renameBatch] = useRenameBatchMutation();

    return (
        <Formik
            initialValues={{ batchName: batch?.batch_name ?? '' }}
            enableReinitialize
            validationSchema={Yup.object({
                batchName: Yup.string()
                    .trim()
                    .required(validationStrings.requiredField.errorMessage)
                    .max(50, validationStrings.maxCharacter[50]),
            })}
            onSubmit={async ({ batchName }) => {
                const trimmedName = batchName.trim();
                await renameBatch({ batchId: batch.batch_id, batchName: trimmedName }).unwrap();
                SuccessToast({ message: `Batch renamed to "${trimmedName}".` });
                onClose();
            }}
        >
            {(formik) => (
                <DialogWithForm
                    dialogTitle={Title}
                    isOpen={isOpen}
                    width={440}
                    secondaryButtonLabel="Cancel"
                    onSecondaryButtonClick={onClose}
                    primaryButtonLabel="Save"
                    isPrimaryButtonDisabled={
                        !(formik.dirty && formik.isValid) || formik.isSubmitting
                    }
                    dialogContent={<TextInputFormik id="batchName" label="Batch Name" required />}
                />
            )}
        </Formik>
    );
};

RenameBatchDialog.Title = Title;

RenameBatchDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    batch: PropTypes.shape({
        batch_id: PropTypes.string.isRequired,
        batch_name: PropTypes.string.isRequired,
    }),
};
